// =============================================================================
// FILE:
// src/modules/pms/task_material/services/materialReservationService.js
// =============================================================================

import axiosClient from "../../../../api/axiosClient";

// =============================================================================
// GET MATERIAL RESERVATION LIST
// =============================================================================

export const getMaterialReservationList = async (

  params = {}

) => {

  const response = await axiosClient.get(

    "/api/pms/task-material-reservation/list",

    {
      params
    }
  );

  return response.data;
};

// ============================================================
// GET PROJECTS
// ============================================================
export async function getProjects() {

  const response =
    await axiosClient.get(
      "/api/pms/projects"
    );

  return response.data;
}
// ============================================================
// GET PROJECT PHASES
// ============================================================
export async function getProjectPhases(
  projectId
) {

  const response =
    await axiosClient.get(

      `/api/pms/wbs/project-phases/${projectId}`
    );

  return response.data;
}
// ============================================================
// GET PHASE TASKS
// ============================================================
export async function getPhaseTasks(
  phaseId
) {

  const response =
    await axiosClient.get(

      `/api/pms/wbs/phase-tasks/${phaseId}`
    );

  return response.data;
}

// ============================================================
// CREATE MATERIAL RESERVATION
// ============================================================
export async function createReservation(
  payload
) {

  const response =
    await axiosClient.post(

      "/api/pms/task-material-reservation/reserve",

      payload
    );

  return response.data;
}